import 'owl.carousel/dist/owl.carousel.min';

import checkIfAnimating from './checkIfAnimating';

/**
 * @param {jQuery} tabs Container with the tabs
 * @param {number} tabIndex Index of the tab
 */
function moveToTab(tabs, tabIndex) {
  tabs.trigger('to.owl.carousel', tabIndex);
}

/**
 * Function that returns the index of the active tab
 * @return {Number}
 */
function getActiveTabIndex() {
  return $('.single-tab.active-circuit').attr('data-circuit');
}

/**
 *
 */
export function startTabs() {
  const $tabs = $('.tabs-container');

  $tabs.owlCarousel({
    dots: false,
    mouseDrag: false,
    responsive: {
      0: {
        items: 5,
      },
      420: {
        items: 7,
      },
      768: {
        items: 10,
      },
      1000: {
        items: 15,
      },
      1135: {
        items: $('.single-tab').length,
      },
    },
    onResize() {
      moveToTab($tabs, $('.single-tab.active-circuit').parent().index());
    },
    onResized() {
      moveToTab($tabs, $('.single-tab.active-circuit').parent().index());
    },
  });

  const activeTabIndex = $('.single-tab.active-circuit').parent().index();

  if (activeTabIndex === $('.owl-item').length) {
    $('.arrow-right').addClass('disabled');
  } else if (activeTabIndex === 0) {
    $('.arrow-left').addClass('disabled');
  }
  moveToTab($tabs, $('.single-tab.active-circuit').parent().index());
}

/**
 * @param {String} circuitNumber Number of the circuit
 */
function changeActiveTab(circuitNumber) {
  $('.single-tab').removeClass('active-circuit');
  $(`.single-tab[data-circuit=${circuitNumber}]`).addClass('active-circuit');
}

/**
 * Function to disable arrows
 * @param {String} arrowSide Left or right arrow
 */
function disableArrow(arrowSide) {
  $(`.arrow-${arrowSide}`).addClass('disabled');
}

/**
 * Gets the tab next or previous a tab depending on arrow direction
 * @param {jQuery} activeTab Tab that is active
 * @param {String} arrowDirection Direction of the tab
 * @return {jQuery}
 */
function getSideTab(activeTab, arrowDirection) {
  const $parentTab = activeTab.parent('.owl-item');
  const $sideItem = arrowDirection === 'left' ? $parentTab.prev() : $parentTab.next();
  return $sideItem.children('.single-tab');
}

/**
 * Check arrows to disable
 * @param {String} arrowDirection Direction of the tab
 */
function checkArrowsToDisable(arrowDirection) {
  const lastTabIndex = $('.owl-item').length - 1;
  const tabToCheck = arrowDirection === 'left' ? 0 : lastTabIndex;
  if ($('.single-tab.active-circuit').parent().index() === tabToCheck) {
    disableArrow(arrowDirection);
  }
}

/**
 * @param {Number} circuitToHide Number of the circuit to hide
 * @param {String} circuitToShow Number of the circuit to show
 */
function showCircuit(circuitToHide, circuitToShow) {
  $(`.circuit-container[data-circuit=${circuitToHide}]`).stop().fadeOut(200, () => {
    $(`.circuit-container[data-circuit=${circuitToShow}]`).stop().fadeIn(200);
  });
  changeActiveTab(circuitToShow);
}

/**
 * Handles click on arrows
 * @param {Object} e event object
 */
export function arrowClick(e) {
  e.preventDefault();
  if ($(this).hasClass('disabled') || checkIfAnimating()) {
    return;
  }
  const arrowDirection = $(this).attr('data-arrow');
  $('.arrow-circuits').removeClass('disabled');
  const $activeTab = $('.single-tab.active-circuit');
  const $sideTab = getSideTab($activeTab, arrowDirection);
  const hasSideTabs = $sideTab.length;

  if (hasSideTabs) {
    const prevOrNext = arrowDirection === 'left' ? 'prev' : 'next';
    $('.tabs-container').trigger(`${prevOrNext}.owl.carousel`, [300]);
    const tabCircuitNumber = $sideTab.attr('data-circuit');
    showCircuit((getActiveTabIndex()), tabCircuitNumber);
    $activeTab.removeClass('active-circuit');
    $sideTab.addClass('active-circuit');
    checkArrowsToDisable(arrowDirection);

    // if (ga) {
    //   const year = $('.container-f1').attr('data-year');
    //   const dataCircuitName = $sideTab.attr('data-circuit-name');
    //   ga('send', 'event', `formula 1 ${year}`, dataCircuitName, 'circuito clicado');
    // }
  }
}

/**
 * Handles click on tabs
 * @param {Object} e Event object
 */
export function clickTab(e) {
  e.preventDefault();
  if ($(this).hasClass('active-circuit')) {
    return;
  }
  $('.arrow-circuits').removeClass('disabled');
  const circuitNumber = $(this).attr('data-circuit');
  const circuitIndex = $(this).parent().index();
  showCircuit((getActiveTabIndex()), circuitNumber);

  if (circuitIndex === $('.owl-item').length - 1) {
    $('.arrow-right').addClass('disabled');
  } else if (circuitIndex === 0) {
    $('.arrow-left').addClass('disabled');
  }

  // if (ga) {
  //   const year = $('.container-f1').attr('data-year');
  //   const dataCircuitName = $(this).attr('data-circuit-name');
  //   ga('send', 'event', `formula 1 ${year}`, dataCircuitName, 'circuito clicado');
  // }
}



// WEBPACK FOOTER //
// local_static/templates/motor/2017/assets/scripts/tabs.js